import { Link } from 'react-router';

import { usePresentVoiceText } from '@/platform/voice/use-voice';

import { adminPanelClassName } from '@/platform/features/admin-panel';
import { type AdminLinkGroup } from '@/platform/lib/admin';

/** Cards for the central administration sections (Verwaltung overview, Startseite). */
export function AdminSectionList({ groups }: { groups: AdminLinkGroup[] }) {
  const present = usePresentVoiceText();
  return (
    <div className="space-y-8">
      {groups.map((group) => (
        <section key={group.id} aria-labelledby={`admin-group-${group.id}`} className="space-y-3">
          <h2 id={`admin-group-${group.id}`} className="text-base font-semibold">
            {group.heading}
          </h2>
          <ul className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
            {group.links.map((link) => (
              <li key={link.id}>
                <Link
                  to={link.to}
                  className={`${adminPanelClassName} block h-full transition-colors hover:border-primary focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none`}
                >
                  <span className="font-medium">{link.label}</span>
                  <span className="mt-1 block text-sm text-muted-foreground">
                    {present(link.description)}
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  );
}
